import { render, staticRenderFns } from "./CLink.vue?vue&type=template&id=10d7da70&"
import script from "./CLink.vue?vue&type=script&lang=ts&"
export * from "./CLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports